import { HeadCell } from '../../components/P4STable/types';
import { SelectPosition } from '../../components/FieldTextInput/types';
import { FormDialogProps } from '../../components/FormDialog/types';
import UserRoles from '../../resources/enums/UserRoles';
import { TableSettings } from './types';
import EditButton from '../../components/Buttons/EditButton';
import { CsvHeader } from '../../components/ExportStatistics/types';

const selectPositions = [
    {
        value: UserRoles.User,
        label: 'User',
    },
    {
        value: UserRoles.Master,
        label: 'Master',
    },
] as SelectPosition[];

const editTextFields = [
    {
        data: selectPositions,
        defaultValue: UserRoles.User,
        id: 'role',
        label: 'Role',
        name: 'role',
        variant: 'outlined',
        required: true,
        type: 'select',
        select: true,
        autoFocus: true,
    },
];

export const columns = [
    {
        id: 'userName',
        numeric: false,
        disablePadding: true,
        label: 'User name',
    },
    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'Email',
    },
    {
        id: 'master',
        numeric: true,
        disablePadding: false,
        label: 'Master',
    },
    {
        id: 'role',
        numeric: true,
        disablePadding: false,
        label: 'Role',
    },
] as HeadCell[];

export const tableSetting = {
    orderBy: 'role',
    filterBy: 'email',
    rowsPerPage: 10,
    pages: [10, 25, 50],
    orderDirection: 'asc',
} as TableSettings;

export const editParams = {
    buttonLabel: 'Edit',
    button: EditButton,
    submitName: 'Save',
    title: 'Edit user',
    textFields: editTextFields,
} as FormDialogProps;

export const statisticsHeaders = [
    { label: 'UID', key: 'uid' },
    { label: 'USER_NAME', key: 'userName' },
    { label: 'MISSION_NAME', key: 'missionName' },
    { label: 'IS_STARTED', key: 'isStarted' },
    { label: 'IS_FINISHED', key: 'isFinished' },
    { label: 'STAGES_COMPLETED', key: 'stagesCompleted' },
    { label: 'STAGE_NAME', key: 'stageName' },
    { label: 'EXERCISES_COMPLETED', key: 'exercisesCompleted' },
    { label: 'SURVEY_COMPLETED', key: 'surveyCompleted' },
] as CsvHeader[];
